// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=test` then `environment.test.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

//
// Create the domain URLs dynamically based on the current window.location.hostname. This allows us to avoid
// CORS issues if we are calling the API from *.online or *.com because we have DNS entries for both that
// point to the same place.
//
const lastDotPosition = window.location.hostname.lastIndexOf('.');
const tld = window.location.hostname.substring(lastDotPosition + 1);
export const environment = {
  production: false,
  apiBaseUrl: `https://api.dev.fs.ralacademy.${tld}`,
  logoutRedirectUrl: `https://www.dev.fs.ralacademy.${tld}/login`,
  serverPort: 8080,
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts